module.exports = __webpack_public_path__ + "img/03.59378e9c.jpg";